import React from 'react';
import Table from '../common/Table';
import tableConfig, { data } from './config';
import Button from '../common/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '../common/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import InputLabel from '@material-ui/core/InputLabel';


const PromoCodes = (props) => {
  const classes = props.classes;
  let config = tableConfig(props);
  
  const onEdit = () => { console.log("edit") }
  const onDelete = () => { console.log("Delete") }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (<div className={classes.wrap}>
    <Button label="+ Add Promo Code" className={classes.button} onClick={() => handleClickOpen() }/>
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth={true}>
        <DialogTitle id="form-dialog-title">Add Promo Code</DialogTitle>
        <DialogContent>
          <TextField
            id="standard-full-width"
            label="Promo Code Name"
            placeholder="Write Promo code name" 
          />
          <div className={classes.discount}>
          <InputLabel shrink={true} classes={{ root: classes.discountlabel }}>Discount Amount</InputLabel>
          <div className={classes.textField}>
            <TextField
              id="standard-full-width"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyIcon />
                  </InputAdornment>
                ),
              }}            
              fullWidth={false}           
            />
          </div>
          <InputLabel >or</InputLabel>
          <div className={classes.textField}>
          <TextField
            id="standard-full-width"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <AttachMoneyIcon />
                </InputAdornment>
              ),
            }} 
            fullWidth={false}                
          />
          </div>
         </div>
         
         <Button onClick={handleClose} color="primary" label="Add"/>
        </DialogContent>
    </Dialog>
    <Table 
      tableConfig={config} 
      data={data}
      onEdit={onEdit}
      onDelete={onDelete}
    />
    </div>)
};

export default PromoCodes;
